// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__38x2c","info":"PatientInfo_info__3at5U"};